export default {
      id: "huge-xlsx-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#huge-xlsx",
      toString: function () {
        return this.url;
      }
    }